<template>
    <div>




        <EmailSignup class="my-4 my-md-7"/>
        <OrSeparator class="my-7"/>
        <google-sign-in action="signup" class="mt-4" />
        <SigninWithFacebookButton action="signup" class="mt-4" />




    </div>
</template>



<script setup>

import EmailSignup from './EmailSignup.vue';
import GoogleSignIn from '@/components/Auth/Common/SigninWithGoogleButton.vue';
import OrSeparator from '@/components/Auth/AuthDialog/Elements/OrSeparator.vue';
import SigninWithFacebookButton from '@/components/Auth/Common/SigninWithFacebookButton.vue';

</script>